import React, { useEffect, useState } from "react";
import { Rept, sto } from "../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { mt } from "../../../St/comps/cStyle";
import { reFormatDate } from "../../../utils/utils";
import { insh } from "../../../Context/InshSt";
import { ButtonBase, colors, Container, makeStyles, Table, TableCell, TableHead, TableRow, TextField, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useRptCa, useRptMain } from '../../../St/Reviews/UseStyle';
import { BorderBottom } from "@material-ui/icons";

function TotalsCashairCar(props) {
    const { found, inv, sta, onUnmountComplete } = props;
    const { t } = useTranslation(["forms", "translation"]);
    const cls = useRptAF();
    const clas = useRptCa();
    const clasm = useRptMain();

    // const [data, setData] = useState(Rept.data);
    const styleE = {
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleE1 = {
        BorderBottom: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleHH = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleNum = {
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.9rem",
        color: "black",
        fontWeight: "bold",
    };

    const styleNum1 = {
        BorderBottom: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.9rem",
        color: "black",
        fontWeight: "bold",
    };

    const styleA = {

        textAlign: "center",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    useEffect(() => {
        setTimeout(async () => {
            onUnmountComplete();
        }, 0);
    }, []);
    return (
        <Grid item container >
            <Grid item container style={{ direction: "rtl", fontFamily: "Amiri-Regular", marginBottom: "0.5rem", marginTop: "0.7rem" }}>
            <Grid item xs={5} container style={styleHH}>
                    <Grid item xs={12}>
                        {"البائع"}
                    </Grid>
                    <Grid item xs={12}>
                        {sto.usernames}
                    </Grid>
                    <Grid item xs={12}>
                        {"العودة في /كيلومتر"}
                    </Grid>
                    <Grid item xs={12}>
                        {sta.tot.CarStructure}
                    </Grid>
                </Grid>
                <Grid item xs={7} container style={styleHH}>
                    <Grid item xs={7} style={styleE1}>
                        {"الاجمالي"}
                    </Grid>
                    <Grid item xs={5} style={styleNum1}>
                        {(sta?.tot?.tot_net - sta?.tot?.amountOfVat + sta?.tot?.discount)?.toFixed(2)}
                    </Grid>
                    <Grid item xs={7} style={styleE}>
                        {"الخصم"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {sta?.tot?.discount?.toFixed(2)}
                    </Grid>
                    <Grid item xs={7} style={styleE}>
                        {"الضريبة"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {(sta?.tot?.amountOfVat)?.toFixed(2)}
                    </Grid>
                    <Grid item xs={7} style={styleE}>
                        {"الصافي"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {sta?.tot?.amountWithVat?.toFixed(2)}
                    </Grid>

                </Grid>

            </Grid>

            <Grid item xs={12} style={{ textAlign: "right", border: "solid 0.1px", }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        inputProps={{ borderColor: "black", color:'red',fontWeight:"bold",fontSize:"0.9rem",fontFamily: "Amiri-Regular" }}
                        type="text"
                        name="notes"
                        multiline
                        value={found.BillNotes}
                    />
                    {/* <div aria-multiline style={{ fontWeight: "bold", fontSize: "0.8rem" }}> {inv.notes}     </div> */}
                </Grid>

            <Grid item xs={12} style={{ textAlign: "center" }} spacing={0} >
                <ButtonBase
                    style={{ borderRadius: "1", margin: 0, padding: 0, alignContent: "center" }}
                >
                    <img
                        src={`data:image/jpeg;base64,${inv.qr_image}`}
                        style={{ height: "45mm", width: "45mm" }}
                        alt={found.nameA}
                    />
                </ButtonBase>
            </Grid>



        </Grid>
    );
}

export default TotalsCashairCar;
